import React, { useState } from "react";
import { Rate, Typography, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import ManageCouponButton from "components/buttons/ManageCouponButton";

import {
  CheckOutlined,
  SafetyOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import Table from "components/Tables/Table";
import Fetch from "components/Fetch";
import colors from "constants/palette";
import DeleteButton from "components/buttons/DeleteButton";
import Button from "components/buttons/Button";
import { StyledModal } from "components/App/styled";

export default function CustomTable({ data, reload, setReload }) {
  const [activeItem, setActiveItem] = useState(null);
  const [updateModal, setUpdateModal] = useState(false);
  const showModal = () => {
    setActiveItem(true);
  };

  // const handleOk = () => {
  //   setActiveItem(false);
  // };

  const handleUpdate = (status) => {
    Fetch.post(
      "/comments/changeStatus",
      { id: activeItem.id, product_id: activeItem.product_id, status },
      (res) => {
        console.log("comments", res);
        if (res?.id) {
          setReload(true);
          setActiveItem(null);
        } else {
          if (res?.errors?.name) {
            message.error(res?.errors.name[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
          return false;
        }
      }
    );
  };
  const handleReject = () => {
    handleUpdate(2);
  };
  const handleApprove = () => {
    handleUpdate(1);
  };

  return (
    <>
      <ManageCouponButton
        reload={setReload}
        oldData={updateModal}
        visible={updateModal ? true : false}
        setVisible={setUpdateModal}
        buttonStyle={{ display: "none" }}
      />

      <Table
        loading={reload}
        columns={tableHeaders}
        dataSource={
          data?.length &&
          data?.map((item, index) => ({
            title: item.title,
            code: item.code,
            used: (
              <>
                {item.used}
                <span style={{ fontSize: 11 }}>/{item.count}</span>
              </>
            ),
            expire_date: new Intl.DateTimeFormat("fa-IR").format(
              new Date(item.expire_date)
            ),
            created_at: new Intl.DateTimeFormat("fa-IR").format(
              new Date(item.created_at)
            ),
            actions: (
              <div className="center">
                <Button onClick={() => setUpdateModal(item)}>
                  <EditOutlined />
                </Button>
                <DeleteButton
                  id={item.id}
                  reload={setReload}
                  title="کالا"
                  link="products"
                />
              </div>
            ),
            key: index + 1,
          }))
        }
      />
    </>
  );
}

const tableHeaders = [
  {
    title: "شمار",
    dataIndex: "key",
    key: "key",
    align: "center",
    width: "80px",
  },
  { title: "عنوان", dataIndex: "title", key: "title", align: "center" },
  {
    title: "کد اختصاصی",
    dataIndex: "code",
    key: "code",
    align: "center",
  },
  {
    title: "دفعات استفاده شده",
    dataIndex: "used",
    key: "used",
    align: "center",
  },
  {
    title: "تاریخ انقضاء",
    dataIndex: "expire_date",
    key: "expire_date",
    align: "center",
  },
  {
    title: "تاریخ ساخت",
    dataIndex: "created_at",
    key: "created_at",
    align: "center",
  },
  {
    title: "اعمال",
    dataIndex: "actions",
    key: "actions",
    align: "center",
  },
];
